// extracted by mini-css-extract-plugin
export var quoteContainer = "quote-module--quoteContainer--eFA-w";
export var section = "quote-module--section--eM2HF";
export var column = "quote-module--column--ccvci";
export var openQuote = "quote-module--openQuote--bpoLA";
export var closeQuote = "quote-module--closeQuote--4AoKG";